<template>
  <div>
      <comment v-for="comment in comments" :comment="comment" :key="comment.id"></comment>
  </div>
</template>

<script>
  import comment from './comment'
    export default {
      props:{
         comments:{
          type: Array,
          required: true
        }
      },
       components: { comment },
       data(){
        return{

        }
       },
       methods:{

       }
     }
</script>
